import React from 'react';
import PropTypes from 'prop-types';
import { useFeatureFlag } from 'common/hooks';
import authorizationShape from '../authorizationShape';
import AuthorizationHistoryLineItem from './AuthorizationHistoryLineItem';
import EditReasonLineItem from './EditReasonLineItem';
import { formatAmount, formatDates } from '../utils';

const AcceptedAuthorizationFields = ({ authorization }) => {
  const editReasonFeatureEnabled = useFeatureFlag('pays-10493-service-authorization-edit-reasons');

  return (
    <>
      <AuthorizationHistoryLineItem field="Authorized Amount">
        {formatAmount(authorization)}
      </AuthorizationHistoryLineItem>
      <AuthorizationHistoryLineItem field="Authorized Service Delivery Date(s)">
        {formatDates(authorization)}
      </AuthorizationHistoryLineItem>
      <AuthorizationHistoryLineItem field="Payer Authorization ID">
        {authorization.payer_authorization_number || 'N/A'}
      </AuthorizationHistoryLineItem>
      {editReasonFeatureEnabled && authorization.service_authorization_edit_reason && (
        <EditReasonLineItem authorization={authorization} />
      )}
      <AuthorizationHistoryLineItem field="Notes">
        {authorization.reviewer_note ? (
          <div className="whitespace-pre-line">{authorization.reviewer_note}</div>
        ) : (
          'N/A'
        )}
      </AuthorizationHistoryLineItem>
    </>
  );
};

AcceptedAuthorizationFields.propTypes = {
  authorization: PropTypes.shape(authorizationShape).isRequired,
};

export default AcceptedAuthorizationFields;
